module.exports = __webpack_public_path__ + "img/kitkitphoto11.caed180d.jpg";